import { getServerRequest, putServerRequest, postServerRequest } from '@/helpers/serverRequest.helper';
import { store } from '@/store/store';
const httpURL = store.getters.httpURL;

export const getTransferencias = async () => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/transferencias`;
    return await getServerRequest(url, config);
}

export const guardarTransferencia = async(data) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/transferencia`;
    return await putServerRequest(url, data, config);
}

export const agregaraTransferencia = async(transferencia, expediente) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/transferencia/${transferencia}/${expediente}`;
    return await putServerRequest(url, {}, config);
}

export const getTransferencia = async (id) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/transferencia/${id}`;
    return await getServerRequest(url, config);
}

export const getArchivo = async (data) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }, responseType: 'blob'};
    const url = `${httpURL}/archivo/documentoTransferencia`;
    return await postServerRequest(url, {datos:data}, config);
}